<template>
  <div class="main">
    <!-- <abbvie-header>AbbVie商业流向管理系统</abbvie-header> -->
    <van-tabs v-model="active" :lazy-render="false" @change="changeTab">
      <van-tab title="预估概览">
        <EstimateOverview ref="estimateOverview" @viewDetail="viewDetail"></EstimateOverview>
      </van-tab>
      <van-tab title="预估详情">
        <EstimateDetail ref="estimateDetail"></EstimateDetail>
      </van-tab>
      <van-tab title="填写统计" v-if="hasAuth('mobile:estimate:fill_statistics')">
        <EstimateStatistics ref="estimateStatistics"></EstimateStatistics>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import _ from 'lodash'
import moment from 'moment'
import handleCopy from '@/utils/clipboard'
import EstimateOverview from './modules/EstimateOverview.vue'
import EstimateDetail from './modules/EstimateDetail.vue'
import EstimateStatistics from './modules/EstimateStatistics.vue'

export default {
  components: {
    EstimateOverview,
    EstimateDetail,
    EstimateStatistics,
  },
  data() {
    return {
      active: 0,
    }
  },
  watch: {},
  computed: {
    // 校验是否有查看权限
    hasAuth() {
      return auth => {
        let permissionList = []
        let authList = JSON.parse(sessionStorage.getItem('LOGIN_USER_BUTTON_AUTH') || '[]')
        for (let auth of authList) {
          if (auth.type != '2') {
            permissionList.push(auth)
          }
        }
        let permissions = []
        for (let item of permissionList) {
          if (item.type != '2') {
            //update--begin--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU-------
            if (item.action) {
              if (item.action.includes(',')) {
                let split = item.action.split(',')
                for (let i = 0; i < split.length; i++) {
                  if (!split[i] || split[i].length == 0) {
                    continue
                  }
                  permissions.push(split[i])
                }
              } else {
                permissions.push(item.action)
              }
            }
            //update--end--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU------
          }
        }
        if (!permissions.includes(auth)) {
          return false
        } else {
          return true
        }
      }
    },
  },
  mounted() {},
  methods: {
    changeTab(name) {
      if (name == 0) {
        // 触发埋点
        this.$sensors.track('ButtonClicked', {
          $element_type: 'tab',
          $url_path: '/estimate',
          $element_content: '预估概览',
        })
        this.$refs.estimateOverview.search()
      } else if (name == 1) {
        // 触发埋点
        this.$sensors.track('ButtonClicked', {
          $element_type: 'tab',
          $url_path: '/estimate',
          $element_content: '预估详情',
        })
        this.$refs.estimateDetail.search()
      } else {
        // 触发埋点
        this.$sensors.track('ButtonClicked', {
          $element_type: 'tab',
          $url_path: '/estimate',
          $element_content: '填写统计',
        })
        this.$refs.estimateStatistics.search()
      }
    },
    viewDetail(record) {
      this.active = 1
      this.$refs.estimateDetail.getViewDetail(record)
    },
  },
}
</script>

<style lang="less" scoped>
.ml3 {
  margin-left: 3px;
}
.ml6 {
  margin-left: 6px;
}
.main {
  padding-top: 45px;
}
/deep/ .van-tabs__wrap {
  width: 100%;
  height: 45px !important;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f6f7fb;
  z-index: 999;
}

/deep/ .van-tabs__nav {
  background: none;
  .van-tab__text {
    font-size: 15px;
    font-weight: 600;
  }
  .van-tab--active {
    color: #4e7092;
  }
}
/deep/ .van-tabs__line {
  background-color: #02a7f0;
  width: 20%;
}
</style>
